import React, { Component } from 'react'
import { StaticBox, FlowTable, Modal } from 'components/basic'
import { Installation } from 'config'
import ReactHtmlParser from 'react-html-parser'
import http from 'API/http'

class Tickets extends Component {
  constructor (props) {
    super(props)
    this.state = {
      tickets: [],
      ticketModal: false,
      loading: true,
      accessId: ''
    }
  }
  componentDidMount () {
    this.getTickets(this.props.accessId)
  }
  componentWillReceiveProps (props) {
    if (props.accessId === this.props.accessId) return
    this.getTickets(props.accessId)
  }
  async getTickets (accessId) {
    this.setState({loading: true})
    var [err, res] = await http.get('2.4/accesses/' + accessId + '/tickets')
    if (err) return this.setState({loading: false, accessId: accessId})
    this.setState({tickets: res.data, accessId: accessId, loading: false})
  }
  getStatus (status) {
    switch (status) {
      case 0:
        return 'NEW'
      case 1:
        return 'OPEN'
      case 2:
        return 'CLEARED'
      case 3:
        return 'CLOSED'
      default:
        return status
    }
  }
  render () {
    if (!Installation.enable.tickets) return false
    return (
      <div>
        <StaticBox cols={12} icon='ticket' title='Tickets' buttons={[
          {icon: 'fa-plus', event: e => (window.location = '/#/ticket/create/' + this.state.accessId), hidden: !Installation.enable.ticketsCreate},
          {icon: 'fa-plus', event: e => this.setState({ticketModal: Installation.ticketRules}), hidden: Installation.enable.ticketsCreate}
        ]}>
          <FlowTable hideHeaders emptyIcon='fa-ticket' emptyText='No Tickets Available' loading={this.state.loading} paginatable={10} data={this.state.tickets.map(ticket => [
            <a href={'/#/ticket/' + ticket.coTicketReference} className='table-link'><i className='fa fa-folder-open-o' /></a>,
            ticket.coTicketReference,
            <p style={{'width': '300px'}} className='ellipsis no-margin'>{ticket.heading}</p>,
            this.getStatus(ticket.status),
            ticket.createdBy
          ])}>
            <tr>
              <th className='buttons' />
              <th className='buttons'>ID</th>
              <th>Title</th>
              <th>Status</th>
              <th>Created By</th>
            </tr>
          </FlowTable>
        </StaticBox>
        <Modal title='Ticket Information' isOpen={this.state.ticketModal} close={e => this.setState({ticketModal: false})}>
          {ReactHtmlParser(Installation.ticketRules)}
        </Modal>
      </div>
    )
  }
}
export default Tickets



// WEBPACK FOOTER //
// ./src/projects/access-gui/components/access/Tickets.js